"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ActionBarContext_1 = __importDefault(require("../ActionBar/ActionBarContext"));
var common_1 = require("@scuf/common");
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var HeaderRender = /** @class */ (function (_super) {
    __extends(HeaderRender, _super);
    function HeaderRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderRender.prototype.render = function () {
        var _a = this.props, data = _a.data, selectionMode = _a.selectionMode, search = _a.search, totalRecords = _a.totalRecords, selections = _a.selections, actionBar = _a.actionBar, menuBar = _a.menuBar, hideActionBar = _a.hideActionBar, showActionBar = _a.showActionBar;
        var displayActionBar = actionBar && selectionMode && showActionBar && selections;
        var length = 0;
        if (totalRecords !== undefined) {
            length = totalRecords;
        }
        else if (data) {
            length = data.length;
        }
        if (displayActionBar) {
            return (React.createElement(ActionBarContext_1.default.Provider, { value: { total: length, selectionMode: selectionMode, selections: selections, toggle: hideActionBar } }, actionBar));
        }
        else if (search) {
            var _b = this.props, searchPlaceholder_1 = _b.searchPlaceholder, globalFilterValue_1 = _b.globalFilterValue, onSearchChange_1 = _b.onSearchChange;
            return (React.createElement(localization_1.TranslationConsumer, null, function (t) { return (React.createElement("div", { className: "filter-bar" },
                React.createElement("div", { className: "search-output" },
                    React.createElement(common_1.Input, { search: true, value: globalFilterValue_1, uncontrolled: true, className: "global-filter", onChange: function (value) { return onSearchChange_1(value); }, placeholder: "" + (searchPlaceholder_1 ? searchPlaceholder_1 : t('Global Search')) }),
                    React.createElement("div", { className: "total-count" },
                        length,
                        " ",
                        t('Total'))),
                menuBar)); }));
        }
        else if (menuBar) {
            return React.createElement("div", { className: "filter-bar no-search" }, menuBar);
        }
        else {
            return null;
        }
    };
    return HeaderRender;
}(react_1.Component));
exports.default = HeaderRender;
//# sourceMappingURL=Header.js.map